.#{$namespace}-upload {
	.#{$namespace}-upload-input {
		display: none;
	}
}
